import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeEvery } from 'redux-saga/effects';

import { AnyRequestActionType, anyRequestSlice } from 'src/store/anyRequest/slice';
import { httpResponseCheckSaga } from 'src/store/commonSaga';
import { SafeAnyType } from 'src/utils/safeAny';

function* anyRequestSaga({
  payload: { apiFunction, uniqueId, data },
}: PayloadAction<AnyRequestActionType<Record<string, SafeAnyType>>>) {
  const internalId = Date.now(); // the id for detecting the same item in the store when a response is come

  yield put(anyRequestSlice.actions.setInternalId({ uniqueId, internalId }));

  yield httpResponseCheckSaga(
    function* () {
      return yield call(apiFunction, data);
    },
    function* (data) {
      yield put(anyRequestSlice.actions.ok({ data, uniqueId, internalId }));
    },
    function* (e, data) {
      yield put(anyRequestSlice.actions.error({ error: e, uniqueId, internalId, data }));
    }
  );
}

export function* anyRequestSagas(): Generator {
  yield takeEvery(anyRequestSlice.actions.start.type, anyRequestSaga);
}
